<template>
    <div class="home-container">
        <el-row class="home" :gutter="responsiveGutter">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                <div class="title">欢迎使用点名系统！</div>
                <el-card shadow="hover" class="user-card">
                    <div class="xingxi">个人信息</div>
                    <div class="user">
                        <img :src="imageUrl + avatar" alt="用户头像">
                        <div class="user-info">
                            <p class="name">{{nickname}}</p>
                        </div>
                    </div>
                    <div class="login-info">
                        <p>上次登录时间:<span>{{lastLoginTime | formatDate}}</span></p>
                    </div>
                </el-card>
            </el-col>
         
            <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
                <el-card class="chart-card">
                    <div ref="videoEchart" class="echart-container"></div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as echarts from "echarts";
import { debounce } from 'lodash';

export default {
    name: 'HomePage',
    data() {
        return {
            avatar: '',
            nickname: '',
            lastLoginTime: '',
            tableData: [],
            observer: null,
            pieOptions: {
                title: {
                    text: '课程销售额统计',
                    left: 'center',
                },
                tooltip: {
                    trigger: "item",
                    formatter: '{a} <br/>{b}: ￥{c} ({d}%)'
                },
                legend: {
                    orient: 'horizontal', // 小屏幕改为水平显示
                    bottom: 0,
                    left: 'center',
                },
                color: [
                    "#0f78f4",
                    "#dd536b",
                    "#9462e5",
                    "#a6a6a6",
                    "#e1bb22",
                    "#39c362",
                    "#3ed1cf",
                ],
                series: [
                    {
                        name: '销售额',
                        type: 'pie',
                        radius: ['40%', '70%'], // 自适应半径
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            formatter: '{b}: ￥{c}'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: [],
                    }
                ]
            },
            screenWidth: document.documentElement.clientWidth,
        }
    },
    computed: {
        responsiveGutter() {
            // 根据屏幕宽度调整间距
            return this.screenWidth < 768 ? 10 : 20;
        }
    },
    filters: {
        formatDate(value) {
            if (!value) return '未知'
            const date = new Date(value)
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        },
    },
    created() {
        this.userInfo()
        this.getMemberList()
        this.$bus.$on('update-user-info', (data) => {
            if(data == 1){
                this.userInfo()
            }
        })
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); // 初始化
    },
    methods: {
        handleResize: debounce(function() {
            this.screenWidth = document.documentElement.clientWidth;
            if (this.$refs.videoEchart) {
                const chart = echarts.getInstanceByDom(this.$refs.videoEchart);
                if (chart) {
                    chart.resize();
                }
            }
        }, 200),
        
        getMemberList() {
            this.$http.get('/api/members')
                .then(response => {
                    const memberData = response.data.data;
                    this.processMemberData(memberData);
                })
                .catch(error => {
                    console.error('获取会员列表失败:', error);
                });
        },
        processMemberData(memberData) {
            const courseMap = {};
            const today = new Date();
            const todayStr = today.toISOString().split('T')[0];
            const month = today.getMonth() + 1;
            const year = today.getFullYear();
            
            memberData.forEach(item => {
                const courseName = item.courseName;
                const price = item.course.price || 0;
                const updatedAt = new Date(item.course.updatedAt);
                const isToday = updatedAt.toISOString().split('T')[0] === todayStr;
                const isThisMonth = updatedAt.getMonth() + 1 === month && updatedAt.getFullYear() === year;
                
                if (!courseMap[courseName]) {
                    courseMap[courseName] = {
                        courseName: courseName,
                        todayBuy: 0,
                        monthBuy: 0,
                        totalBuy: 0,
                        price: price
                    };
                }
                
                courseMap[courseName].totalBuy += price;
                if (isToday) courseMap[courseName].todayBuy += price;
                if (isThisMonth) courseMap[courseName].monthBuy += price;
            });
            
            this.tableData = Object.values(courseMap);
            
            const chartData = this.tableData.map(item => ({
                value: item.totalBuy,
                name: item.courseName
            }));
            
            this.pieOptions.series[0].data = chartData;
            
            this.$nextTick(() => {
                const ThreeEcharts = echarts.init(this.$refs.videoEchart);
                ThreeEcharts.setOption(this.pieOptions);
                
                // 响应式调整
                this.observer = new ResizeObserver(() => {
                    ThreeEcharts.resize();
                });
                
                if (this.$refs.videoEchart) {
                    this.observer.observe(this.$refs.videoEchart);
                }
            });
        },
        userInfo() {
            this.$http.get('/api/adminAuth/profile')
                .then(response => {
                    this.avatar = response.data.data.avatar;
                    this.nickname = response.data.data.nickname;
                    this.lastLoginTime = response.data.data.lastLoginTime;
                })
                .catch(error => {
                    console.error('获取用户信息失败:', error);
                    this.$message.error('获取用户信息失败');
                });
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
</script>

<style lang="less" scoped>
.home-container {
    padding: 10px;
    box-sizing: border-box;
}

.home {
    height: 100%;
    overflow: hidden;
    
    .user-card {
        margin-bottom: 20px;
    }
    
    .chart-card {
        margin-top: 20px;
        
        @media (max-width: 768px) {
            margin-top: 10px;
        }
    }

    .user {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
        padding-bottom: 20px;

        img {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            margin-bottom: 15px;
            
            @media (max-width: 768px) {
                width: 100px;
                height: 100px;
            }
        }
    }

    .user-info {
        .name {
            font-size: 24px;
            margin-bottom: 10px;
            
            @media (max-width: 768px) {
                font-size: 20px;
            }
        }
    }

    .login-info {
        p {
            line-height: 24px;
            font-size: 14px;
            color: #999;
            text-align: center;

            span {
                color: #666;
                margin-left: 10px;
            }
        }
    }

    .xingxi {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        
        @media (max-width: 768px) {
            font-size: 16px;
        }
    }
    
    .title {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        
        @media (max-width: 768px) {
            margin-bottom: 15px;
            font-size: 16px;
        }
    }
    
    .echart-container {
        width: 100%;
        height: 400px;
        
        @media (max-width: 768px) {
            height: 300px;
        }
        
        @media (max-width: 480px) {
            height: 250px;
        }
    }
}

// 响应式调整
@media (max-width: 992px) {
    .home {
        .el-col {
            margin-bottom: 15px;
        }
    }
}
</style>